import { createContext, useContext } from "react";
import { io } from 'socket.io-client';
import { read_cookie } from 'sfcookies';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || '';
const token = read_cookie( 'pppcalc' );

interface SocketContextType {
    on: (event: string, callback: (...args: any[]) => void) => void;
    // Add other methods/events if needed
}

export const socket = io(SOCKET_URL, {
    auth: {
        token
    }
});
export const SocketContext = createContext<SocketContextType>({ on: () => {} });


// import { createContext } from 'react';

/*import { io } from "socket.io-client";

const socket = io("http://localhost:5000");

export const SocketContext = createContext({});

export function SocketProvider(props: any) {
    return (
        <SocketContext.Provider value={{}}>
            {props.children}
        </SocketContext.Provider>
    )
}*/
